/**
 * Thin helpers for Documents hub Signatures + public /sign flow (ZRF-ESIGN-01).
 */

export function formatSignatureDate(value) {
  if (!value) return '—';
  try {
    if (typeof value === 'string') {
      const d = new Date(value);
      return Number.isNaN(d.getTime()) ? value.slice(0, 10) : d.toISOString().slice(0, 10);
    }
    if (typeof value.toDate === 'function') {
      return value.toDate().toISOString().slice(0, 10);
    }
    if (typeof value._seconds === 'number') {
      return new Date(value._seconds * 1000).toISOString().slice(0, 10);
    }
    if (value instanceof Date) {
      return value.toISOString().slice(0, 10);
    }
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? '—' : d.toISOString().slice(0, 10);
  } catch {
    return '—';
  }
}

function toDate(value) {
  if (!value) return null;
  try {
    if (typeof value.toDate === 'function') return value.toDate();
    if (typeof value._seconds === 'number') return new Date(value._seconds * 1000);
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

/**
 * Normalize API / Firestore signature request for hub UI.
 * Prefer custom `id` (sig-…) for public /sign links; keep firestoreId when present.
 */
export function normalizeSignatureRequest(raw = {}, documents = []) {
  const firestoreId = raw.firestoreId || null;
  const requestId = raw.id || firestoreId || '';
  const documentId = raw.documentId || '';
  const linked = documents.find((d) => d.id === documentId);
  const expiresAt = toDate(raw.expiresAt || raw.expiryDate);
  let status = raw.status || 'pending';

  if (
    expiresAt &&
    expiresAt.getTime() < Date.now() &&
    status !== 'completed' &&
    status !== 'cancelled'
  ) {
    status = 'expired';
  }

  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '';

  return {
    ...raw,
    id: requestId,
    firestoreId,
    documentId,
    documentTitle:
      raw.documentTitle ||
      linked?.title ||
      raw.documentName ||
      (documentId ? `Document ${documentId}` : 'Untitled document'),
    createdDate: formatSignatureDate(raw.createdAt || raw.createdDate),
    expiryDate: formatSignatureDate(raw.expiresAt || raw.expiryDate),
    status,
    signers: Array.isArray(raw.signers) ? raw.signers : [],
    message: raw.message || '',
    signingUrl: requestId ? `${origin}/sign/${requestId}` : '',
    hasPdf: Boolean(raw.pdfUrls?.unsigned || raw.pdfUrls?.signed || raw.pdfUrl),
    fields: Array.isArray(raw.fields) ? raw.fields : []
  };
}

export function pendingSignerEmails(request) {
  const signers = Array.isArray(request?.signers) ? request.signers : [];
  return signers.filter((s) => s?.email && s.status !== 'signed');
}
